import queryKeys from '@/constants/queryKeys';
import { getPeerSupportFromMyOrgById } from '@/services/api/requests/organization';
import { useQuery } from '@tanstack/react-query';

const usePeerSupportById = (memberCareId: string) => {
  const { isLoading, data } = useQuery({
    queryKey: [queryKeys.memberCare.memberCareById, memberCareId],
    queryFn: () => getPeerSupportFromMyOrgById(memberCareId),
  });

  return { isLoading, data };
};

export default usePeerSupportById;
